export default __webpack_public_path__ + "static/media/car-manufac.57ce4ce5.png";